// Components
const UsersComponent = () => import(/* webpackPrefetch: true, webpackChunkName: "users-component"*/'@/app/views/main-view/users/components/user-component/user-component.vue');
const UserPetsComponent = () => import(/* webpackPrefetch: true, webpackChunkName: "user-pets-component"*/'@/app/views/main-view/users/components/user-pet-component/user-pet-component.vue');
const UserAdminComponent = () => import(/* webpackPrefetch: true, webpackChunkName: "user-admin-component"*/'@/app/views/main-view/users/components/user-admin-component/user-admin-component.vue');

// Constants
import { USER_ROLE } from '@/app/constants/constants';

export default {
	name: 'UsersContainer',
	components: {
		UsersComponent,
		UserPetsComponent,
		UserAdminComponent
	},
	data() {
		return {
			tabs: [
				{
					id: 'users',
					label: 'Users',
					component: 'UsersComponent',
					active: true
				}
			],
			selectedTabComponent: 'UsersComponent',
			userFilter: ''
		}
	},
	computed: {
		getActiveTab() {
			return this.tabs.find(tab => tab.active);
		},
		getIsUserSuperAdmin() {
			const { userRole } = this.$store.getters.getUserDetails;
			const { SUPER_ADMIN } = USER_ROLE;

			return userRole === SUPER_ADMIN;
		},
		getFromSubFilter() {
			return this.$store.getters.getFromSubFilter;
		}
	},
	created() {
		this.checkUserRole();

		if (this.getFromSubFilter) {
			const { filter, activeTab } = this.getFromSubFilter;
			if (activeTab === 'users') {
				this.handleUserFilter(filter);
			}
		}
	},
	beforeDestroy() {
		this.$store.commit('clearFromSubFilter');
	},
	methods: {
		checkUserRole() {
			if (this.getIsUserSuperAdmin) {
				// This ensures that the admin tab won't be duplicated.
				if (this.tabs.length !== 3) {
					const adminTab = {
						id: 'admin',
						label: 'Admin',
						component: 'UserAdminComponent',
						active: false
					};

					this.tabs.push(adminTab);
				}
			}  else if (this.tabs.length === 3) {
				// Remove admin tab if it exists and user is not a Super Admin.
				this.tabs.pop();
			}
		},
		setActiveTab(selectedTab) {
			this.tabs = this.tabs.map(tab => {
				// set the selected tab to active
				if (tab.id === selectedTab) {
					tab.active = true;
					this.selectedTabComponent = tab.component;
				} else {
					tab.active = false;
				}

				return tab;
			});
		},
		handleUserFilter(user) {
			this.userFilter = user;
			this.setActiveTab('users');
		},
		handleSubPreFilter({owner, petName}) {
			this.$store.commit('setSubscriptionPreFilterMode', true);
			this.$store.commit('setFromUsersFilter', {
				emailAddress: owner,
				petName
			});

			this.$router.push('/subscriptions');
		},
		handleTreatPreFilter({owner, petName}) {
			this.$store.commit('setTreatmentPreFilterMode', true);
			this.$store.commit('setFromUsersFilter', {
				emailAddress: owner,
				petName
			});

			this.$router.push('/treatments');
		},
		handleClearUserFilter() {
			this.userFilter = '';
		}
	}
}